export default __webpack_public_path__ + "static/media/Tutorial-Step-6.6a4d5e68.jpg";